import * as Sentry from "@sentry/react";
import { ErrorBoundary } from "@suspensive/react";
import App from "app/App";
import { appInit } from "app/init/AppInit";
import { IndexError } from "idx/IndexError";
import { IndexLoading } from "idx/IndexLoading";
import LogRocket from "logrocket";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import reportWebVitals from "reportWebVitals";
import { AppConfig } from "shared/config/AppConfig";
import { isDev } from "shared/utils/DevUtils";

appInit();

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <StrictMode>
    <ErrorBoundary
      fallback={IndexError}
      onError={(error) => {
        if (!isDev) {
          Sentry.captureException(error);
          if (AppConfig.logRocket) {
            LogRocket.track("query-error", { error: error.message });
          }
        }
      }}
    >
      <Suspense fallback={<IndexLoading />}>
        <App />
      </Suspense>
    </ErrorBoundary>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
